const state = {
	//messages: {}
	messages: []
};

const mutations = {
	'SET_ERRORS'(state, messages) {
		state.messages.push(messages);
	},
	'UNSET_ERRORS'(state) {
		state.messages = [];
	}
};
const actions = {
	setErrors({commit}, messages) {
		commit('SET_ERRORS', messages);
	},
	unsetErrors({commit}) {
		commit('UNSET_ERRORS');
	}
};
const getters = {
	getErrorMessages (state) {
		return state.messages;
	},
	errorsActive (state) {
		return state.messages.length > 0;
	}
};
export default {
	state,
	mutations,
	actions,
	getters
};


// WEBPACK FOOTER //
// ./src/Banet/store/modules/errors.js